import axios from 'axios'
import router from '../router'
import store from '../store'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
  withCredentials: true  // 允许携带cookie
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response?.status === 401) {
      store.commit('CLEAR_USER')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default api
